import { useState } from 'react';

interface LanguageProps {
  langHandler?: (locale: string) => void;
}
const useLanguageSelector = ({ langHandler }: LanguageProps) => {
  const [showLanguageModal, setShowLanguageModal] = useState(false);
  const handleLanguageChange = (locale: string) => {
    setShowLanguageModal(false);
    langHandler?.(locale);
  };
  const onCloseHandler = () => setShowLanguageModal(false);
  const languageClickHandler = () => setShowLanguageModal(!showLanguageModal);
  return {
    showLanguageModal,
    handleLanguageChange,
    onCloseHandler,
    languageClickHandler,
  };
};

export default useLanguageSelector;
